export default {
      id: "timeline-session-supervised-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#timeline-session-supervised",
      toString: function () {
        return this.url;
      }
    }